import React from 'react';

export default function Footer() {
    return (
        <footer className="bg-[#111111] text-background pt-24 pb-12 px-6 md:px-16 rounded-t-[4rem] relative z-20 mt-[-2rem]">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-20">
                    <div className="max-w-sm">
                        <h3 className="font-heading font-bold text-3xl text-background mb-4">ROSSIEAU</h3>
                        <p className="font-subheading text-background/60">
                            We engineer 1:1 pixel-perfect Flutter applications for iOS, Android, and Web.
                        </p>
                    </div>

                    <div className="flex gap-16">
                        <div className="flex flex-col gap-4">
                            <span className="font-data text-xs tracking-widest text-background/40 uppercase mb-2">Index</span>
                            <a href="#expertise" className="hover:text-accent font-subheading transition-colors">Expertise</a>
                            <a href="#portfolio" className="hover:text-accent font-subheading transition-colors">Portfolio</a>
                            <a href="#philosophy" className="hover:text-accent font-subheading transition-colors">Philosophy</a>
                            <a href="#protocol" className="hover:text-accent font-subheading transition-colors">Protocol</a>
                        </div>
                        <div className="flex flex-col gap-4">
                            <span className="font-data text-xs tracking-widest text-background/40 uppercase mb-2">Legal</span>
                            <a href="#" className="hover:text-accent font-subheading transition-colors">Privacy</a>
                            <a href="#" className="hover:text-accent font-subheading transition-colors">Terms</a>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-background/10 gap-4">
                    <p className="font-subheading text-background/40 text-sm">
                        © {new Date().getFullYear()} Rossieau Creative Concepts.
                    </p>

                    <div className="flex items-center gap-3 px-4 py-2 bg-background/5 rounded-full border border-background/10">
                        <div className="w-2 h-2 rounded-full bg-[#00FF41] animate-pulse" />
                        <span className="font-data text-xs text-background/60 tracking-widest uppercase">System Operational</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
